<form class="form" [formGroup]="searchForm" (keydown.enter)="search()">
  <ion-item
    class="form__item form__item--search"
    [ngClass]="{
      'form__item--noborder': !border,
      'form__item--border-light': border
    }"
  >
    <ion-input
      class="form__input form__input--search"
      formControlName="keyword"
      [ngClass]="{
      'form__input--md': size === inputSizes.NORMAL,
      'form__input--lg': size === inputSizes.BIG
    }"
      [placeholder]="placeholder"
    ></ion-input>

    <ion-button
      class="button button--normal button--circle"
      (click)="search()"
      [ngClass]="{
        'button--circle--big': size === inputSizes.BIG
      }"
    >
      <i class="fa-regular fa-magnifying-glass"></i>
    </ion-button>
  </ion-item>
</form>
